// extracted by mini-css-extract-plugin
module.exports = {"back":"V_LBbQ1j5pHWtYOMeN9R","button":"Uk6lb4tgSX3k8HvOas78","reachout":"yZzbeyGbPzBiYv8wC3cC","resend":"E4waQK3anuORNNsWLOoh"};